import { Button, Stack } from "@mantine/core";
import { useEffect, useMemo, useRef, useState } from "react";
import AnswersLeadItem from "./AnswersLeadItem";
import { requestNextPage } from "../../../../../api/PRMAPI";
import { useLeadsContainerStore } from "../../../../../stores/LeadsStore";
import { IconReload } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { parseProspectDatafields } from "../../utils";

const AnswersLeft = ({
  container,
  setContainer,
  current,
  setCurrent,
  loading,
}) => {
  const lang = useLanguage((s) => s.language);
  const updateContainer = useLeadsContainerStore((s) => s.updateContainer);
  const ref = useRef(null);
  const containerColor = useMemo(
    () => (container?.color ? `#${container?.color}` : null),
    [container]
  );

  const handleClick = (val) => {
    setCurrent(val);
  };

  const [loadingNext, setLoadingNext] = useState(false);
  const handleNextPage = () => {
    if (container?.nextPageUrl) {
      setLoadingNext(true);
      return requestNextPage(container.nextPageUrl)
        .then((response) => {
          if (setContainer) {
            setContainer({
              nextPageUrl: response.data?.next_page,
              loadingNext: false,
              items: [
                ...container.items,
                ...response.data.results.map((x) => ({
                  ...x,
                  ...parseProspectDatafields(x),
                  id: x.prm_contacts_id,
                })),
              ],
            });
          } else {
            updateContainer(container.id, {
              nextPageUrl: response.data?.next_page,
              items: [...container.items, ...response.data.results],
              loadingNext: false,
            });
          }
        })
        .finally(() => setLoadingNext(false));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        let activeElement = document.getElementById("prospect-" + current?.id);
        ref.current.scrollTop = activeElement
          ? activeElement.offsetTop - 250
          : 0;
      }
    }, 50);
  }, [current?.id]);

  return (
    <Stack
      w={"20%"}
      gap={0}
      style={{
        overflow: "auto",
        scrollBehavior: "smooth",
      }}
      h={"75vh"}
      pr={"sm"}
      ref={ref}
    >
      <Stack gap={"xs"}>
        {container.items.map((item, i) => (
          <AnswersLeadItem
            key={item.id}
            index={i}
            active={current?.id && current?.id === item.id}
            color={containerColor}
            current={item}
            handleClick={() => handleClick(item)}
            disabled={loading}
          />
        ))}
        {container?.nextPageUrl && (
          <Button
            onClick={handleNextPage}
            variant="light"
            mt={"sm"}
            leftSection={<IconReload size={16} />}
            loading={loadingNext}
          >
            {lang.settings.load_more}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default AnswersLeft;
